import { makeStyles } from "@material-ui/core";

export const usePersonalizationAndDataStyles = makeStyles(() => ({
    switch: {
        float: "right"
    },
    subText: {
        marginTop: 12
    },
    content: {
        paddingBottom: 64
    }
}));